export default id => {
  const videeoData = document.querySelector(`.js-productVideeoData[data-product-id="${id}"]`);

  const {
    sku,
    price,
    currency,
    shopName,
  } = videeoData.dataset;

  return {
    shopName,
    data: {
      sku,
      currency,
      price: parseInt(price),
    }
  };
}